import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import Link from "next/link";

import styles from "./email_check.module.scss";

export const EmailCheck = () => {
  return (
    <section className={styles.section_auth}>
      <div className={styles.side_bg}></div>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.left_wrapper}>
            <div className={styles.logo_and_title_wrapper}>
              <Image
                src={getAssets("assets/logo-beta.webp")}
                alt="UniSearch Logo"
                blurDataURL={getAssets("assets/logo-beta.webp")}
                placeholder="blur"
                width={186}
                height={30}
              />
              <div className={styles.title}>
                Discover study abroad opportunities around the world with
                UniSearch
              </div>
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets(
                  "assets/images/auth/illustration_forget_password.png"
                )}
                alt="singin"
              />
            </div>
          </div>
          <div className={styles.right_wrapper}>
            <div className={styles.form_title_wrapper}>
              <div className={styles.form_title}>Please Check Your Email</div>
              <div className={styles.form_sub_title}>
                We have sent you a password reset link! Please check your email
                to proceed.
              </div>
            </div>

            <div className={styles.resend_text}>
              Didn’t receive an email?{" "}
              <Link legacyBehavior href="/forgot-password">
                Try Again
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailCheck;
